// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fpmz","question":"styles_question__VmSSX","inputVisibleButton":"styles_inputVisibleButton__3sqcu","note":"styles_note__1H58r"};